
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { PredictionSumaryMixin } from './prediction-sumary-mixin'

@Options({})
export default class DPredictionSumaryView extends Mixins(
    PredictionSumaryMixin
) {}
